// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"94d99958","453":"21fe579a"}[chunkId] + ".chunk.js";
};